var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ModelDto } from './model';
import { IsNotEmpty, IsEmail, IsUrl, IsOptional, IsString, MinLength, MaxLength, Max, Min, IsNumber } from 'class-validator';
import { Match } from '@/dto/decorators/match.decorator';
import { assign } from 'lodash';
export var UserSettingsPaths;
(function (UserSettingsPaths) {
    UserSettingsPaths["USER_PROFILE_PUBLIC_ADDRESS"] = "profile.public_address";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_CHAT_MESSAGE"] = "email_notifications.chat_message";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_POST_REACTION"] = "email_notifications.post_reaction";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_NEIGHBOUR_POST"] = "email_notifications.neighbour_post";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_EVENT_INVITATION"] = "email_notifications.event_invitation";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_NEW_NEAR_NEIGHBOURHOOD_REGISTRATIONS"] = "email_notifications.new_near_neighbourhood_registrations";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_CHANGE_REQUESTS"] = "email_notifications.change_requests";
    UserSettingsPaths["USER_EMAIL_NOTIFICATION_GROUP_SUBSCRIPTION_POST"] = "email_notifications.group_subscription_post";
})(UserSettingsPaths || (UserSettingsPaths = {}));
var UserDto = /** @class */ (function (_super) {
    __extends(UserDto, _super);
    function UserDto(user) {
        var _this = _super.call(this, user) || this;
        if (user) {
            _this.firstName = user.first_name;
            _this.lastName = user.last_name;
            _this.email = user.email;
            _this.password = user.password;
            _this.passwordConfirmation = user.password_confirmation;
            _this.profilePicture = user === null || user === void 0 ? void 0 : user.profile_picture;
        }
        return _this;
    }
    UserDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.first_name = this.firstName;
        model.last_name = this.lastName;
        model.email = this.email;
        model.password = this.password;
        model.password_confirmation = this.passwordConfirmation;
        model.profile_picture_path = this.profilePicture;
        return model;
    };
    UserDto.prototype.toGqlModel = function (merge) {
        var superModel = _super.prototype.toGqlModel.call(this, merge);
        return assign(superModel, {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
        }, merge);
    };
    __decorate([
        IsNotEmpty(),
        MaxLength(50),
        __metadata("design:type", String)
    ], UserDto.prototype, "firstName", void 0);
    __decorate([
        IsNotEmpty(),
        MaxLength(50),
        __metadata("design:type", String)
    ], UserDto.prototype, "lastName", void 0);
    __decorate([
        IsEmail(),
        IsNotEmpty(),
        __metadata("design:type", String)
    ], UserDto.prototype, "email", void 0);
    __decorate([
        IsOptional(),
        MinLength(8),
        Match('passwordConfirmation'),
        __metadata("design:type", String)
    ], UserDto.prototype, "password", void 0);
    __decorate([
        IsOptional(),
        MinLength(8),
        __metadata("design:type", String)
    ], UserDto.prototype, "passwordConfirmation", void 0);
    __decorate([
        IsUrl(),
        IsOptional(),
        __metadata("design:type", String)
    ], UserDto.prototype, "profilePicture", void 0);
    return UserDto;
}(ModelDto));
export { UserDto };
var ProfileDto = /** @class */ (function (_super) {
    __extends(ProfileDto, _super);
    function ProfileDto(profile) {
        var _this = _super.call(this, profile) || this;
        if (profile) {
            _this.bio = profile.bio;
            _this.streetName = profile.street_name;
            _this.houseNumber = profile.house_number;
            _this.zipCode = profile.zip_code;
            _this.city = profile.city;
        }
        return _this;
    }
    ProfileDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.bio = this.bio;
        model.street_name = this.streetName;
        model.house_number = this.houseNumber;
        model.zip_code = this.zipCode;
        model.city = this.city;
        return model;
    };
    ProfileDto.prototype.toGqlModel = function (merge) {
        var superModel = _super.prototype.toGqlModel.call(this, merge);
        return assign(superModel, {
            bio: this.bio,
            street_name: this.streetName,
            house_number: this.houseNumber,
            zip_code: this.zipCode,
            city: this.city,
        }, merge);
    };
    __decorate([
        IsOptional(),
        IsString(),
        __metadata("design:type", String)
    ], ProfileDto.prototype, "bio", void 0);
    __decorate([
        IsNotEmpty(),
        MaxLength(100),
        __metadata("design:type", String)
    ], ProfileDto.prototype, "streetName", void 0);
    __decorate([
        IsNotEmpty(),
        MaxLength(50),
        __metadata("design:type", String)
    ], ProfileDto.prototype, "houseNumber", void 0);
    __decorate([
        IsNotEmpty(),
        IsNumber(),
        Min(1000),
        Max(9999),
        __metadata("design:type", Number)
    ], ProfileDto.prototype, "zipCode", void 0);
    __decorate([
        IsNotEmpty(),
        MaxLength(50),
        __metadata("design:type", String)
    ], ProfileDto.prototype, "city", void 0);
    return ProfileDto;
}(ModelDto));
export { ProfileDto };
